// material-ui
import { useTheme } from '@mui/material/styles';
import { IconButton, Tooltip } from '@mui/material';

// project imports
import { useDispatch, useSelector } from 'store';
import { setOpen } from 'store/slices/askJivan';
import JivanFace from '../../AskJivanWidget/jivanFace';

// same rounded-square treatment as the sidebar toggler on the left of the bar; the
// hover colours stay on while the panel is open so the button reads as pressed
const launcherColors = (theme, open) => {
    const dark = theme.palette.mode === 'dark';
    const resting = {
        background: dark ? theme.palette.dark.main : theme.palette.secondary.light,
        color: dark ? theme.palette.secondary.main : theme.palette.secondary.dark
    };
    const active = {
        background: dark ? theme.palette.secondary.main : theme.palette.secondary.dark,
        color: theme.palette.secondary.light
    };
    return {
        ...(open ? active : resting),
        '&:hover': active
    };
};

// ==============================|| ASK JIVAN LAUNCHER ||============================== //

// Top-bar toggle for the Ask Jivan panel (AskJivanWidget). Rendered only when platform
// admin enabled Ask Jivan for the org; the widget fetches that flag.
const AskJivanSection = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { enabled, open } = useSelector((state) => state.askJivan);

    if (!enabled) {
        return null;
    }

    return (
        <Tooltip title={open ? 'Close Ask Jivan' : 'Ask Jivan'}>
            <IconButton
                aria-label={open ? 'Close Ask Jivan' : 'Ask Jivan'}
                aria-pressed={open}
                data-testid="ask-jivan-launcher"
                onClick={() => dispatch(setOpen(!open))}
                sx={{
                    ...theme.typography.commonAvatar,
                    ...theme.typography.mediumAvatar,
                    p: 0.5,
                    transition: 'all .2s ease-in-out',
                    ...launcherColors(theme, open)
                }}
            >
                <JivanFace size={26} />
            </IconButton>
        </Tooltip>
    );
};

export default AskJivanSection;
